import * as React from 'react';
import { Image, ScrollView, StyleSheet, Switch, TextInput, View, useWindowDimensions } from 'react-native';
import { Text } from 'react-native-paper';
import * as AppConstants from "../context/AppConstants";
import * as AppState from "../context/AppState";
import { useNavigation } from '@react-navigation/native';
import { useSelector, useDispatch } from 'react-redux';
import { CustomButton } from '../components/CustomButton';
import { AppContext } from "../context/AppContext";
import * as AppUtilities from "../context/AppUtilities";

const styles = StyleSheet.create({
  modal: {
    alignSelf: "center",
    backgroundColor: "white",
    padding: 20,
    borderRadius: 2,
    shadowColor: "rgba(0, 0, 0, 0.3)",
    shadowOffset: {width: 1, height: 1},
  },
  line: {
    paddingBottom: 15,
    flexWrap: "wrap",
    flexDirection: "row",
    alignItems: "center",
  },
  toggle: {
    marginVertical: 10,
    marginRight: 10,
  },
});

export function Subscribe({ closePopup }) {
  const { width, height } = useWindowDimensions();
  const [subscribeEmail, setSubscribeEmail] = React.useState("");
  const [subscribeZip, setSubscribeZip] = React.useState("");
  const [subscribeExtra, setSubscribeExtra] = React.useState(true);
  const { showPermanentSnack, showTemporarySnack, hideSnack, showSpinner, hideSpinner } = React.useContext(AppContext);
  const emailInput = React.useRef();

  function onSubscribe() {
    if (AppUtilities.isBlank(subscribeZip)) {
      alert("Zip code required");
    } else if (AppUtilities.isBlank(subscribeEmail)) {
      alert("Email address required");
    } else if (!AppConstants.EMAIL_REGEX.test(subscribeEmail)) {
      alert("Invalid email");
    } else {
      closePopup();
      subscribe();
    }
  }

  async function subscribe() {
    try {
      showSpinner();
      hideSnack();

      await AppUtilities.fetchUnauthorized(
        "Subscribe.subscribe",
        "/find_humane/api/subscribe",
        "POST",
        {
          email: subscribeEmail,
          zip: subscribeZip,
          extra: subscribeExtra,
        }
      );

      showTemporarySnack("Successfully subscribed");

    } catch (e) {
      //showPermanentSnack(AppUtilities.getErrors(e), "Retry", () => subscribe());
      AppUtilities.handleException(e, "Subscribe.subscribe");
    } finally {
      hideSpinner();
    }
  }

  return (
    <View style={{ maxHeight: height - 50, marginTop: 50 }}>
      <ScrollView style={[styles.modal, { maxWidth: width - 50 }]}>
        <Text variant="bodyLarge">Subscribe</Text>
        <Text style={{ paddingVertical: 10 }}>Get an email when new products or locations are added near you:</Text>
        <TextInput
          placeholder="Zip code"
          placeholderTextColor="#777777"
          value={subscribeZip}
          onChangeText={setSubscribeZip}
          style={AppConstants.STYLES.width100PmarginVertical10border1}
          returnKeyType="next"
          autoComplete="postal-code"
          keyboardType="number-pad"
          onSubmitEditing={() => emailInput.current.focus()}
        />

        <TextInput
          ref={emailInput}
          placeholder="Your email"
          placeholderTextColor="#777777"
          value={subscribeEmail}
          onChangeText={setSubscribeEmail}
          style={AppConstants.STYLES.width100PmarginVertical10border1}
          returnKeyType="send"
          autoComplete="email"
          keyboardType="email-address"
          textContentType="emailAddress"
          onSubmitEditing={onSubscribe}
        />

        <View style={styles.line}>
          <Switch
            key="subscribeExtra"
            checked={subscribeExtra}
            style={styles.toggle}
            onValueChange={() => setSubscribeExtra(!subscribeExtra)}
            value={subscribeExtra}
          />
          <Text onPress={() => setSubscribeExtra(!subscribeExtra)}>Other news from Find Humane and animal welfare non-profits</Text>
        </View>

        <View style={{ flexDirection: "row", alignSelf: "center", gap: 20 }}>
          <CustomButton onPress={onSubscribe}>Subscribe</CustomButton>
          <CustomButton onPress={closePopup}>Cancel</CustomButton>
        </View>
      </ScrollView>
    </View>
  );
}
